<div class="ns-body">
  <div class="kpi">
    @if (loading) {
      <p-progressSpinner styleClass="kpi-spinner" strokeWidth="4" />
    } @else if (!error) {
      <a routerLink="/domains" class="kpi-value kpi-link">{{ domainsCount | number }}</a>
    } @else {
      <span class="kpi-error"><i class="pi pi-exclamation-triangle"></i></span>
    }
    <div class="kpi-label">Domains</div>
  </div>
  <div class="kpi">
    @if (loading) {
      <p-progressSpinner styleClass="kpi-spinner" strokeWidth="4" />
    } @else if (!error) {
      <div class="kpi-value">{{ usersCount | number }}</div>
    } @else {
      <span class="kpi-error"><i class="pi pi-exclamation-triangle"></i></span>
    }
    <div class="kpi-label">Users</div>
  </div>
</div>

@if (!loading && error) {
  <div class="ns-error">
    <span class="ns-error__msg">Failed to load</span>
    <p-button icon="pi pi-refresh" [text]="true" size="small" pTooltip="Retry" (onClick)="fetch()" />
  </div>
}
